import dashboardsService from '@/helpers/api/dashboards.service'

const OLD_STORAGE_KEY = 'graspil_dashboards_mock'
const MIGRATED_FLAG_KEY = 'graspil_dashboards_migrated'
const SIDEBAR_CACHE_KEY = 'sidebar_dashboards_cache'

/**
 * One-time migration: dashboards used to live only in localStorage (dashboards.service.mock).
 * Pushes any leftover local dashboards to the real backend (dashboards.service) so users don't
 * lose them now that the mock is gone. Runs once per browser (guarded by MIGRATED_FLAG_KEY), call
 * after the user is authenticated since it needs to hit the real API.
 */
export async function migrateLocalDashboards() {
    if (localStorage.getItem(MIGRATED_FLAG_KEY)) return

    let localDashboards = []
    try {
        const raw = localStorage.getItem(OLD_STORAGE_KEY)
        localDashboards = raw ? JSON.parse(raw) : []
    } catch (e) {
        localDashboards = []
    }

    if (!Array.isArray(localDashboards)) {
        localDashboards = []
    }

    for (const d of localDashboards) {
        try {
            await dashboardsService.create({
                name: d?.name || 'Dashboard',
                description: d?.description || null,
                layout: d?.layout || []
            })
        } catch (e) {
            console.error('Failed to migrate local dashboard', d, e)
        }
    }

    localStorage.setItem(MIGRATED_FLAG_KEY, '1')
    localStorage.removeItem(OLD_STORAGE_KEY)
    localStorage.removeItem(SIDEBAR_CACHE_KEY)
}
